/*
 syte: https://openbase.com/js/react-toastify
 demo: https://fkhadra.github.io/react-toastify/introduction
 docs: https://fkhadra.github.io/react-toastify/introduction/
 */

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Slide, Zoom, Flip, Bounce } from 'react-toastify';
import { cssTransition } from 'react-toastify';

import "../../Components/PopupMessage/Toastify.css";

export const TYPE_MESSAGE_EXCEEDS_LENGTH = "_warning_length";
export const TYPE_MESSAGE_WRONG_CASE = "_warning_case";
export const TYPE_MESSAGE_UNAVAILABLE_SYMBOL = "_warning_unavailsym";

export function showPopopMessage(messageText, messageTypeId) {

    //toast.dismiss();
    var toastType = "default" ;

    switch (messageTypeId.indexOf('_warning_') > -1) {
        case true:
            toastType = toast.TYPE.WARNING;
            break;
        default:
            break;
    }
    switch (messageTypeId.indexOf('_error_') > -1) {
        case true:
            toastType = toast.TYPE.ERROR;
            break;
        default:
            break;
    }
    switch (messageTypeId.indexOf('_success_') > -1) {
        case true:
            toastType = toast.TYPE.SUCCESS;
            break;
        default:
            break;
    }
    switch (messageTypeId.indexOf('_info_') > -1) {
        case true:
            toastType = toast.TYPE.INFO;
            break;
        default:
            break;
    }

    if (toast.isActive(messageTypeId)) {
        toast.update(messageTypeId, { autoClose: 2200, render: messageText });
    }
    else {
        toast(messageText, {
            toastId: messageTypeId,
            position: toast.POSITION.TOP_RIGHT,
            type: toastType,
            theme: "colored",
            transition: Bounce,  // Slide, Zoom, Flip, Bounce
            pauseOnFocusLoss: true,
            autoClose: 1700
        });
    }


}


